import React from 'react';
import { messages } from '../../common/messages';
import config from '../../views/config/App_data';

const ReadingList = ({
  readingData = [],
  onViewList,
  onBeginChapter,
  isViewListIcon = true,
  tableName = '',
}) => {
  return readingData.length > 0 ? (
    <div className='row'>
      <div className='col-md-12'>
        <div className='card height_70vh'>
          {tableName && <div className='card-header'>{tableName}</div>}
          <div className='table_responsive_wrapper'>
            <div className='table-responsive'>
              <table className='table_white_bg table'>
                <thead>
                  <tr className='border_top_0'>
                    <th width='90'>#</th>
                    <th>{messages.READING}</th>
                    <th>{messages.ACTION}</th>
                  </tr>
                </thead>
                <tbody>
                  {readingData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <td>{item.reading}</td>
                      <td>
                        {isViewListIcon && (
                          <span className='tooltip_wrap margin_right_20'>
                            <img
                              src={`${config.frontend_url}/img/question_bank/eye_icon.svg`}
                              className='pointer_class'
                              alt='View List'
                              width='23'
                              onClick={() => onViewList(item)}
                            />
                            <div className='tootip_box'>{messages.VIEW_LIST}</div>
                          </span>
                        )}

                        <span className='tooltip_wrap'>
                          <img
                            src={`${config.frontend_url}/img/question_bank/open_book_icon.svg`}
                            className='pointer_class'
                            alt=''
                            width='21'
                            id={item.id}
                            onClick={() => onBeginChapter(item)}
                            title=''
                          />
                          <div className='tootip_box'>{messages.BEGIN_CHAPTER}</div>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <h1>No data Found</h1>
  );
};

export default ReadingList;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/ReadingList.jsx